<template>

  <section class="font-open-sans" style="background: radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 0%, #e6e9f0 100%)">
    <div class="flex flex-col items-center gap-6 px-5 py-16 mx-auto md:flex-row lg:flex-row">
      <div class="order-last w-full pt-6 md:w-1/2 md:mb-0 dyn_img">
        <nuxt-img :src="imageSrc" :alt="imageAlt"  loading="lazy" format="webp" sizes="xs:295px sm:440px md:600px lg:231px xl:400px 2xl:800px" class="w-full max-w-lg mx-auto" />
      </div>
      <div class="flex flex-col items-center text-center lg:flex-grow md:w-1/2">
        <h1 class="max-w-md h2" :style="{ color: headingColor }">
          <div class="text-4xl font-bold tracking-wide font-ww-medium" v-html="mainHeading"></div>
        </h1>
        <a @click.prevent="scrollTo(buttonLink)" class="flex order-last px-10 cursor-pointer btn-red lg:px-16 lg:py-4 md:w-auto">
          <p class="inline text-2xl md:text-3xl font-ww-medium" v-html="buttonText"></p>
          <svg class="inline-flex ml-6 align-baseline" xmlns="http://www.w3.org/2000/svg" width="25px" viewBox="0 0 1000 1000">
            <path d="M573.5 500.1c.4-8-2.7-16.6-9.3-23.2L105.3 19.5C93.6 7.9 76 6.8 65.8 16.9c-10.1 10.1-9.0 27.7 2.6 39.3L513.8 500 68.5 943.8c-11.6 11.6-12.8 29.2-2.6 39.3 10.1 10.1 27.8 8.9 39.4-2.6l458.9-457.4c6.6-6.6 9.6-15 9.3-23zm358.2-23.2L472.8 19.5c-11.6-11.6-29.3-12.7-39.4-2.6-10.1 10.1-9 27.7 2.6 39.3L881.3 500 436.0 943.8c-11.6 11.6-12.8 29.2-2.6 39.3 10.1 10.1 27.8 8.9 39.4-2.6l458.9-457.4c6.6-6.6 9.7-15 9.4-23.0c0.3-8-2.8-16.6-9.4-23.2z" :fill="buttonTextColor" />
          </svg>
        </a>
        <p class="py-4 font-ginger textp" v-html="paragraphText" :style="{ color: paragraphColor }">

        </p>
      </div>
    </div>
  </section>

</template>



<script setup>
const props = defineProps({

  mainHeading: {
    type: String,
    default: 'TRY LIFEBOOST TODAY FOR UP TO 58% OFF!',
  },
  headingColor: {
    type: String,
    default: '#000000',
  },
  buttonText: {
    type: String,
    default: 'Save 58% Now',
  },
  buttonLink: {
    type: String,
    default: '#steps',
  },
  paragraphText: {
    type: String,
    default: 'We know you’ll love Lifeboost Coffee. Today you can try it for up to 58% off (while supplies last).',
  },
  paragraphColor: {
    type: String,
    default: '#000000',
  },
  imageSrc: {
    type: String,
    default: 'assets/images/coffee-with-beans.png',
  },
  imageAlt: {
    type: String,
    default: 'coffee',
  },
  buttonTextColor: {
    type: String,
    default: '#fff',
  },
});

defineBuilderComponent({
    friendlyName: "Content Image Right2",
    inputs: [
        {
            name: "mainHeading",
            type: "richText",
            defaultValue: "TRY LIFEBOOST TODAY FOR UP TO 58% OFF!"
        },
        {
            name: "headingColor",
            type: "color",
            defaultValue: "#000000"
        },
        {
            name: "buttonText",
            type: "string",
            defaultValue: "Save 58% Now"
        },
        {
            name: "buttonLink",
            type: "string",
            defaultValue: "#steps"
        },
        {
            name: "paragraphText",
            type: "richText",
            defaultValue: "We know you’ll love Lifeboost Coffee. Today you can try it for up to 58% off (while supplies last)."
        },
        {
            name: "paragraphColor",
            type: "color",
            defaultValue: "#000000"
        },
        {
            name: "imageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "assets/images/coffee-with-beans.png"
        },
        {
            name: "imageAlt",
            type: "string",
            defaultValue: "coffee"
        },
        {
            name: "buttonTextColor",
            type: "color",
            defaultValue: "#fff"
        }
    ]
});
</script>